const matchSearchString = (string, match) => (
  String(string)
    .toLowerCase()
    .indexOf(String(match).toLowerCase()) > -1
);
module.exports.matchSearchString = matchSearchString;
